import Link from 'next/link';
import {
  Button,
  Center,
  Fade,
  Heading,
  Modal,
  ModalContent,
  ModalOverlay,
  Text,
  useClipboard,
} from '@chakra-ui/react';
import { Dispatch, SetStateAction } from 'react';

import useAuth from 'src/app/auth/use-auth';
import { SvgIcSuccess } from 'src/components/icons';
import { isBrowser } from 'src/constants/env';
import { CreateAs } from '../article/settings-modal/types';

interface SuccessfullyModalProps {
  actionType: CreateAs;
  projectId: string;
  visible: boolean;
  setIsVisible?: Dispatch<SetStateAction<boolean>>;
}

function SuccessfullyModal({
  actionType,
  projectId,
  visible,
  setIsVisible,
}: SuccessfullyModalProps) {
  const { user } = useAuth();
  const { hasCopied, onCopy } = useClipboard(
    isBrowser() && `${window.location.origin}/project/${projectId}`
  );

  return (
    <Modal
      size="2xl"
      isOpen={visible}
      autoFocus={false}
      onClose={() => setIsVisible((prev) => !prev)}
    >
      <ModalOverlay>
        <Fade in={visible}>
          <ModalContent bg="gray.50" maxWidth="800px">
            <Center
              flexDirection="column"
              height="336px"
              borderTopLeftRadius="4px"
              borderTopRightRadius="4px"
              bg="url(https://source.unsplash.com/Xaanw0s0pMk/640x426)"
              backgroundSize="cover"
            >
              <SvgIcSuccess color="white" fontSize="96px" mb={5} />
              <Heading size="2xl" color="white">
                {actionType === CreateAs.PUBLISH && 'Posted Successfully!'}
                {actionType === CreateAs.DRAFT && 'Saved Successfully!'}
              </Heading>
            </Center>

            <Center flexDirection="column">
              <Text color="gray.500" size="sm" mt="30px" mb={5}>
                You can check your projects on:
              </Text>

              {/* TODO: user can share to community */}
              {/* TODO: user can share to social platforms */}

              {actionType === CreateAs.PUBLISH && (
                <Button variant="ghost" rounded="ellipse" onClick={onCopy}>
                  {hasCopied ? 'Copied!' : 'Copy the Link'}
                </Button>
              )}

              <Link href="/studio/[username]" as={`/studio/@${user?.username}`}>
                <Button
                  rounded="ellipse"
                  bg="gray.900"
                  mt="35px"
                  mb={6}
                  colorScheme="white"
                  _hover={{
                    bg: 'white',
                    color: 'gray.900',
                    border: '1px solid #242526',
                  }}
                >
                  Back to Studio
                </Button>
              </Link>
            </Center>
          </ModalContent>
        </Fade>
      </ModalOverlay>
    </Modal>
  );
}

export default SuccessfullyModal;
